const UNITMOQ_DETAILS_COLLAPSE_INIT = 'data-umoq-collapse-init';

const initUnitmoqProductDetailsCollapse = (scope = document) => {
	scope.querySelectorAll(`unitmoq-product-details:not([${UNITMOQ_DETAILS_COLLAPSE_INIT}])`).forEach((details, index) => {
		const toggle = details.querySelector(':scope > p');
		const panel = toggle?.nextElementSibling;
		if (!toggle || !panel || panel.tagName !== 'DIV') return;

		details.setAttribute(UNITMOQ_DETAILS_COLLAPSE_INIT, '');
		if (!panel.id) {
			panel.id = `unitmoq-product-details-panel-${index}`;
		}

		toggle.setAttribute('role', 'button');
		toggle.setAttribute('tabindex', '0');
		toggle.setAttribute('aria-controls', panel.id);

		const setOpen = (open) => {
			details.classList.toggle('is-open', open);
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
		};

		setOpen(true);

		const onToggle = () => setOpen(!details.classList.contains('is-open'));

		toggle.addEventListener('click', onToggle);
		toggle.addEventListener('keydown', (event) => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault();
				onToggle();
			}
		});
	});
};

const watchUnitmoqProductDetailsCollapse = () => {
	initUnitmoqProductDetailsCollapse();
	const target = document.querySelector('.product__info-container') || document.body;
	if (!target || target.dataset.umoqCollapseObserved) return;
	target.dataset.umoqCollapseObserved = 'true';
	const observer = new MutationObserver(() => initUnitmoqProductDetailsCollapse());
	observer.observe(target, { childList: true, subtree: true });
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', watchUnitmoqProductDetailsCollapse);
} else {
	watchUnitmoqProductDetailsCollapse();
}
